export default __webpack_public_path__ + "static/Ring-Main-Avatar-0327da0b9144d175c07b2d022debb064.png";